<template>
  <div>
    <CommonSettings></CommonSettings>
  </div>
</template>

<script>
import CommonSettings from "@/views/Settings/CommonSettings";
export default {
  name: "Settings",
  components: {
    CommonSettings
  }
};
</script>
